export default __webpack_public_path__ + "static/media/video-blue.286bc991.mp4";